// ##### 24-06-14 Komarov
import parse from 'html-react-parser';
import uniqueId from 'lodash.uniqueid';
import React, { useEffect } from 'react';
// ##### 25-05-21 Komarov
import Star from '../../../../Library/Icons/star';
import CupOfCoffee from '../../../../Library/PageDevices/Animation/CupOfCoffee';
import CartGallery from '../../../../Library/PageDevices/CartGallery/CartGallery';
// ##### Komarov 2025-09-15
import { useDispatch, useSelector } from 'react-redux';
import { useLocalizedText } from '../../../../../hooks/useLocalizedText.js';
import { selectDeviceType } from '../../../../../Redux/selectors';
import { getHotelContent } from '../../../../../Redux/actions/hotelcontent';
import useValidateQuery from '../../../../../helpers/useValidateQuery';
// ##### 23-09-14 Komarov
// import './HotelDetailsCSS.css'

// ##### Komarov 2025-07-14
const ContentDetails = ({ className, hotel_id }) => {
  // ##### Komarov 2025-08-05
  const HotelAddress = useLocalizedText('HotelAddress');
  // ##### 2025-09-11 Komarov
  const hotelcontent_loaded = useSelector(
    state => state.hotelcontent.hotelcontent_loaded
  );
  const hotelData = useSelector(
    state => state.hotelcontent.hotelcontent.data.hotels[hotel_id]
  );
  const dispatch = useDispatch();
  const search_data = useValidateQuery();
  const sale = useSelector(state => state.company.sale_id);

  const { user: currentUser } = useSelector(state => state.auth);
  // ##### 24-03-01 Komarov
  const company_cipher = useSelector(state => state.whitelabel.company_cipher);

  // ##### 24-05-23 Komarov
  const deviceType = useSelector(selectDeviceType);

  // ##### 24-08-05 Komarov
  const company_id = useSelector(state => state.auth.user.company_id);
  const promocode = useSelector(state => state.promocode.promocode);
  const locale = useSelector(state => state.language);
  useEffect(() => {
    if (!hotelData?.image) {
      dispatch(getHotelContent({
        id: search_data?.id,
        city_id: search_data?.city_id,
        language: locale,
        user_id: currentUser.user_id,
        refpartner: company_id,
        sale,
        promocode,
        deviceType,
        company_cipher,
        content_size: 1,
        summary: 0,
      }));
    }
    // ##### 24-03-21 Komarov
  }, []);

  // ##### 25-05-08 Komarov: Fixed error
  return (
    <div className={className} data-component="ContentBlock">
      {!hotelcontent_loaded || !hotelData?.image ? (
        <div
          style={{
            // textAlign: 'center',
            minHeight: '10vw',
            // margin:'auto'
            display: 'flex',
            gridColumn: '1/3',
            // justifyContent:'center'
            // background:'#FFE5CC'
          }}
        >
          <CupOfCoffee />
        </div>
      ) : (
        <>
          <div key={uniqueId()} style={{ gridColumn: '1 / 3' }}>
            {Array.from(hotelData.star_name).map(() => (
              <span
                key={uniqueId()}
                style={{
                  marginLeft: '0.1vw',
                  marginRight: '0.1vw',
                }}
              >
                <Star />
              </span>
            ))}
            <div
              style={{
                fontFamily: 'Arial',
                color: 'blue',
              }}
            >
              {/* ##### 25-03-26 Komarov */}
              <span style={{ fontWeight: 'bold' }}>{parse(HotelAddress)}</span>
              <span>{hotelData.address}</span>
            </div>
          </div>
          <div
            key={uniqueId()}
            className="ContentBlockHotels"
            style={{ height: '55vh' }}
          >
            {parse(hotelData.body)}
          </div>
          <div key={uniqueId()} style={{ gridColumn: '1', gridRow: '2' }}>
            <CartGallery photos={hotelData.image} />
          </div>
        </>
      )}
    </div>
  );
};

export default ContentDetails;
